import { useContext } from 'react';
import PropTypes from 'prop-types';

import { CustomSlateContext } from '../../../CustomSlate';
import { InlineChromiumBugfix } from '../InlineChromiumBugfix';

import { useStyles } from './useStyles';

export const LinkLeaf = ({ style, attributes, element, children }) => {
  const styles = useStyles();

  const { openViewLinkPopup } = useContext(CustomSlateContext);

  const handleNodeLinkClick = (event) => {
    event.preventDefault();

    openViewLinkPopup();
  };

  return (
    <>
      <InlineChromiumBugfix />
      <a
        className={styles.root}
        href={element.url}
        style={style}
        onClick={handleNodeLinkClick}
        {...attributes}
      >
        {children}
      </a>
      <InlineChromiumBugfix />
    </>
  );
};

LinkLeaf.propTypes = {
  attributes: PropTypes.shape().isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  element: PropTypes.shape().isRequired,
  style: PropTypes.object,
};

LinkLeaf.defaultProps = {
  style: null,
};
